import { Form, Input } from "antd";
import styles from "./style.module.scss";
import "./antCustomStyle.scss";

const Plans = () => {

  const onFinish = (values) => {
  };

  return (
    <div className={styles.detailsContainer}>
      <Form name="about-you-form" onFinish={onFinish} requiredMark={false}>
        <div className={styles.mainContent}>
          <Form.Item
            label="Current Plan"
            defaultValue="Premium"
            className={styles.username}
          >
            <Input defaultValue="Premium" />
          </Form.Item>
          <Form.Item
            label="First Name"
            className={styles.username}
          >
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>
          <Form.Item
            label="Last Name"
            className={styles.username}
          >
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>
          <Form.Item
            label="Email Address"
            className={styles.username}
          >
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>

        </div>
      </Form>
    </div>
  );
};

export default Plans;
